export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  methods: {
    hasLink(item) {
      const hasLink = item.url

      if (hasLink) return true

      return false
    },
    isLastItem(index) {
      if (index === this.items.length - 1) return true

      return false
    },
  },
}
